import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { TopBarSlim } from '../TopBarSlim';
import { UseCaseVariationEnums } from '../TopBarSlimEnums';

const DEFAULT_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCaseCustomerSatisfactionTopBarSlim.message',
    defaultMessage: 'Get advanced collaboration tools for your team',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCaseCustomerSatisfactionTopBarSlim.ctaText',
    defaultMessage: 'See details',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

const CREATE_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCaseCustomerSatisfactionTopBarSlim.messageCreate',
    defaultMessage:
      'Get fancy. Brand customer surveys with your logo, colors, and a white label URL.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCaseCustomerSatisfactionTopBarSlim.ctaTextCreate',
    defaultMessage: 'See your options',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

const COLLECT_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCaseCustomerSatisfactionTopBarSlim.messageCollect',
    defaultMessage:
      'Customize your survey email invitation with images, videos, hyperlinks, and colors.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCaseCustomerSatisfactionTopBarSlim.ctaTextCollect',
    defaultMessage: 'See all plans',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

const ANALYZE_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCaseCustomerSatisfactionTopBarSlim.messageAnalyze',
    defaultMessage:
      'Say thank-you to respondents with a custom note and bring them to your website.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCaseCustomerSatisfactionTopBarSlim.ctaTextAnalyze',
    defaultMessage: 'See all plans',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

export type UseCaseCustomerSatisfactionTopBarSlimProps = {
  variation?: UseCaseVariationEnums | null;
};

const VariationToCopy = {
  [UseCaseVariationEnums.create]: CREATE_COPY,
  [UseCaseVariationEnums.collect]: COLLECT_COPY,
  [UseCaseVariationEnums.analyze]: ANALYZE_COPY,
};

export const UseCaseCustomerSatisfactionTopBarSlim: React.FC<UseCaseCustomerSatisfactionTopBarSlimProps> = ({
  variation,
}) => {
  const copy =
    variation && variation in VariationToCopy
      ? VariationToCopy[variation]
      : DEFAULT_COPY;
  const path = variation
    ? `slim_${variation}_upsell_customer_satisfaction`
    : '/mp/team-accounts-new';
  const url = variation
    ? createURL(path, {
        ut_source: 'topbar',
        ut_source2: `slim_${variation}_upsell_customer_satisfaction`,
      })
    : createURL(path, { ut_source: 'new_teams_topbar_slim_paid' });

  return (
    <TopBarSlim
      message={t(copy.MESSAGE)}
      ctaText={t(copy.CTA_TEXT)}
      ctaLink={url}
      ctaNewTab
    />
  );
};

export default UseCaseCustomerSatisfactionTopBarSlim;
